import { createContext } from "react";

export type Locale = "pl-PL" | "en-US";

export type I18nContextValue = {
  locale: Locale;
  isEnglish: boolean;
  t: (text: string) => string;
  setLocale: (locale: Locale) => void;
};

export const defaultValue: I18nContextValue = {
  locale: "pl-PL",
  isEnglish: false,
  t: (text: string) => text,
  setLocale: () => undefined,
};

export const I18nContext = createContext<I18nContextValue>(defaultValue);
